import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDebounce } from "utils";
import { paymentMethod } from "utils/common";
import { dateDisplay } from "utils/moment-util";
import { Input, Button } from "antd";
import styled from "@emotion/styled";
import {
  useHelperPaymentData,
  useConfirmHelperPayment,
} from "utils/payment-public";

export const PublicConfirmPaymentScreen = () => {
  const { helperUuid, salaryRecordUuid } = useParams();
  const [param, setParam] = useState({ helperUuid, salaryRecordUuid });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const {
    data: paymentData,
    retry,
    isError: getPaymentDataError,
  } = useHelperPaymentData(useDebounce(param, 200));

  const {
    mutate,
    isLoading,
    isError,
    isSuccess,
    data: confirmPaymentResult,
  } = useConfirmHelperPayment();

  useEffect(() => {
    if (isSuccess && confirmPaymentResult) {
      alert("salary payment has been successfully confirmed");

      setIsSubmitted(true);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      alert("confirmation of salary receipt failed");
    }
  }, [isError]);

  const handleSubmit = async () => {
    await mutate(helperUuid, salaryRecordUuid);
  };

  return (
    <Container>
      <HeaderContainer>
        <h1>UniCare360</h1>
        {getPaymentDataError ? (
          <h2>an error occurred or the salary was collected</h2>
        ) : (
          <h2>confirmation of the receipt of salaries</h2>
        )}
      </HeaderContainer>

      {!getPaymentDataError && (
        <>
          <RowContainer>
            <b>settlement period:</b> {dateDisplay(paymentData?.settleFrom)} -{" "}
            {dateDisplay(paymentData?.settleTo)}
          </RowContainer>

          <RowContainer>
            <b>salary:</b> ${paymentData?.salary}
          </RowContainer>

          <RowContainer>
            <b>grain delivery method:</b> {paymentMethod(paymentData?.method || 0)}
          </RowContainer>

          <FormContainer>
            {isSubmitted || paymentData?.status === 1 ? (
              <h3 style={{ paddingTop: 30 }}>salary paid</h3>
            ) : (
              <Button
                type="primary"
                onClick={() => handleSubmit()}
                style={{ marginTop: 20 }}
                loading={isLoading}
              >
                confirmation of salary payment
              </Button>
            )}
          </FormContainer>
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 5rem 10px;
  width: 350px;
  margin: 0 auto;
`;

const HeaderContainer = styled.div`
  text-align: center;
  padding-bottom: 20px;
`;

const RowContainer = styled.div`
  padding-bottom: 10px;
`;

const FormContainer = styled.div`
  text-align: center;
`;

const FormTitle = styled.div`
  padding-top: 10px;
  padding-bottom: 5px;
  font-weight: bold;
`;
